const ManagementsUser = [
    {
        name:'Sergej Müller',
        jobTitle:'EU Marketing & Community',
        gitHubLink:  null,
        linkedinLink:  'https://www.linkedin.com/in/sergej-m%C3%BCller-271756246/',
        imgUrl: require("../../assets/serge_new.JPEG")
    },
    {
        name:'Amin Abbasi',
        jobTitle:'Software Engineer',
        gitHubLink:  'https://github.com/aminabs',
        linkedinLink:  'https://www.linkedin.com/in/amin-abbasi-4b4aa138',
        imgUrl: require("../../assets/AminAbbasi.jpeg")
    },
    {
        name:'Kowsar Atazadeh',
        jobTitle:'Game Developer',
        gitHubLink:  'https://github.com/KowsarAtz',
        linkedinLink:  'https://www.linkedin.com/in/kowsar-atazadeh',
        imgUrl: require("../../assets/Kowsaratazadeh.jpeg")
    },
    {
        name:'Rasoul Mirzaie Zadeh',
        jobTitle:'Game Developer',
        gitHubLink:  ' https://github.com/rasoulMrz',
        linkedinLink:  'https://www.linkedin.com/in/rasoul-mirzaie-zadeh',
        imgUrl: require("../../assets/rasoul.jpeg")
    },
    {
        name:'Navid Farokhi',
        jobTitle:'Game Developer',
        gitHubLink:  'https://github.com/Navid-Fkh',
        linkedinLink:  'https://www.linkedin.com/in/mojtaba-f-883778ab',
        imgUrl: require("../../assets/navid.jpeg")
    },
    {
        name:'Mohammadreza Ziraki',
        jobTitle:'Game Developer',
        gitHubLink:  'https://github.com/madrezaz',
        linkedinLink:  'https://www.linkedin.com/in/mohammadreza-ziraki/?originalSubdomain=ir',
        imgUrl: require("../../assets/madrezaz.jpg")
    },
    {
        name:' Margaret Howe',
        jobTitle:' Product Manager',
        gitHubLink:  'https://github.com/NewPerspectiveLLC',
        linkedinLink:  'https://www.linkedin.com/in/meghowe',
        imgUrl: require("../../assets/Margaret.jpg")
    },
    {
        name:' Mohammad Jafari',
        jobTitle:'Blockchain Developer',
        gitHubLink:  'https://github.com/jafari-mi',
        linkedinLink:  'https://www.linkedin.com/in/mohammad-jafari-b38b80142/',
        imgUrl: require("../../assets/imanJafari.jpeg")
    },
    {
        name:'Abbas Nosrati',
        jobTitle:'Frontend Developer',
        gitHubLink:  'https://github.com/abbasnosrati',
        linkedinLink:  'https://www.linkedin.com/in/abbas-nosrati-00b552146',
        imgUrl: require("../../assets/abbasnosrati.jpg")
    },
]
export default  ManagementsUser
